import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Channel from '../views/Channel.vue'
import Login from '../views/Login.vue'
import Search from '../views/Search.vue'
import VideoDetail from '../views/VideoDetail.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            phone: 'home',
            component: Home,
        }, {
            path: '/channel',
            phone: 'channel',
            component: Channel,
        }, {
            path: '/login',
            phone: 'login',
            component: Login,
        }, {
            path: '/search',
            phone: 'search',
            component: Search,
        }, {
            path: '/video-detail',
            phone: 'video-detail',
            component: VideoDetail,
        },
    ],
})
